import UsersTable from "./UsersTable";

export default function AllUsers() {
  return <UsersTable type="all" />;
}
